import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import React from 'react';

const ShareableWorkout = dynamic(
  () => import('@members/pg-workouts/ShareableWorkoutsPage'),
  {
    ssr: false,
  },
);

export default function ShareableWorkoutsPage() {
  const router = useRouter();
  const { query } = router;
  return (
    <ShareableWorkout
      shareWorkoutId={query.shareWorkoutId as string}
      code={query.code as string | undefined}
      rideId={query['ride-id'] as string | undefined}
    />
  );
}
